<template>
  <generic-modal :title="$t('terminal')" ref="generic_modal">
    <form>
      <div class="columns">
        <div class="column">
          <div class="field has-addons">
            <div class="control has-icons-left">
              <input class="input" type="text" v-model="meta.command" />
              <span class="icon is-small is-left">
                <i class="fa fa-code"></i>
              </span>
            </div>
            <div class="control">
              <div class="button is-info" @click="execute">
                <span class="icon">
                  <i class="fa fa-bolt"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="notification is-danger mt-5" v-if="error" v-html="error"></div>
    <template v-slot:footer>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("close") }}</span>
      </button>
      <button class="button is-rounded" @click="clear">
        <span class="icon">
          <i class="fa fa-eraser"></i>
        </span>
        <span>{{ $t("clear") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  //   put,
  post,
  generate_error_message_text,
  //   system_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "TerminalModal",
  components: { GenericModal },
  data() {
    return {
      meta: {},
      error: "",
      // uuid: "",
    };
  },
  computed: {},
  methods: {
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    set_initial_state() {
      let v = this;
      v.meta = {};
      v.error = "";
    },
    clear() {},
    execute() {
      let v = this;
      console.log("execute", v.meta.command);
      v.$root.loader(true);
      post("/system/module/terminal", { command: v.meta.command })
        .then((stdout) => {
          console.log("stdout", stdout);
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style scoped></style>
